const { GET_EMAIL_OTP } = require("../network/request/apiTags");

module.exports = {
  UPDATE_EMAIL: '/updateEmail',
  UPDATE_USERNAME: '/updateEmployerName',
  GENERATE_JWT_TOKEN: '/getToken',
  USER_VERIFICATION: '/customerVerification',
  GENERATE_MOBILE_OTP: '/generateMobileOtp',
  VERIFY_MOBILE_OTP: '/verifyMobileOtp',
  VERIFY_AADHAR_OTP: '/verifyAadhaarOtp',
  UPDATE_PAN: '/updatePAN',
  GETSERVICE: '/getServicesList',
  GETIBOX: '/getIboxMaster',
  Menu_Option: '/getMenuItem',
  Update_Address: '/updateAddress',
  UpdateService: '/updateCustomerDetails',
  GETDYNAMICFIELD: '/getDynamicField',
  block_cheque_credit: '/blockCardDetails',
  Overdue_Menu_Option: '/getDelinquentMenuItem',
  terms_condition: '/getTermCondition',
  get_overdue_details: '/getOverDueDetails',
  getCarApi: "/getCarAPI",
  getQuickPayDetails: '/getQuickPayDetails',
  GETPQOFFERDETAILS: '/getPqOfferDetails',
  GET_IBOX_DETAILS:'/getIboxDetails',
  GET_DELIVERABLES:'/getDeliverables',
  GET_CANCELMANDATE: '/getCancelAutoDebitMandateDetails',
  get_master_date: "/getMasterDate",
  VALIDATESR: '/validateSr',
  DISCREPANT_SUCCESS: '/submitDiscrepantDoc',
  GETFORECLOSEDETAILS: '/getForeCloseDetails',
  SETTLEMENTREQUEST:'/settlementRequestDIY',
  GETMASTERDATE:'/getMasterDate',
  getEasyPay: '/getEazyPay',
  transactionStatus: '/getTransactionDetails',
  DEACTIVATE_TOKEN: '/deActivateToken',
  GENERATEAADAHR: '/generateAadhaarOtp',
  VERIFYPAN: '/verifyPan',
  AADHARVALIDATE: '/verifyAadhaarOtp',
  testApi: '/testApi',
  CONFIRMSRDETAILS: '/confirmSRDetails',
  GETSRDETAILS: '/getSRDetails',
  GETCONFIRMDETAILS: '/getConfirmDetails',
  SMSTOCUSTOMER: '/smsToCustomer',
  GETSERVICEDETAILS: '/getServiceDetails',
  GETPINCODEDETAILS: '/transferAccount',
  GETPINCODEDETAIL: '/getPincodeDetails',
  GETDECRYPTEDDATA: '/decryptedData',
  GETREKYCDECRYPTEDDATA: '/getDecryptedData',
  GETREKYCDECRYPTEDDATATESTSERVICE: '/getDecryptedTestDataService',
  UPLOADFILES: '/uploadDocument',
  VERIFYACCOUNTNUMBER: '/getAccountStatus',
  GETORDERDETAILS: '/getOrderDetails',
  SAVETRANSACTIONDETAILS: '/getCreditDetails',
  GETIINDETAILS: '/getIinNpciDetails',
  GETBANKDETAILS: '/getBankName',
  GETLANGAUGE: '/getLanguage',
  GETPAYMENTDETAILS: '/getPaymentDetails',
  SENDDETAILS: '/sendDetails',
  VERIFYCREDIT: '/getCreditStatus',
  GETDEBITDETAILS: '/getDebitDetails',
  GETDEBITUSERDETAILS: '/getDebitUserDetails',
  GETCHEQUESTATUS: '/getChequeStatus',
  GETOVERDUEMENU: '/getOverdueMenuItem',
  GETCIBIL: '/getCibilDetails',
  GETBITLY: '/redirectBitly',
  SENDSMS: '/sendSms',
  CONSENTWHATSAPP: '/getConsentDetails',
  GETUSERDETAILS: '/getCustomerDetials',
  GETPPACODE: '/getPpaCode',
  GETSEARCH: '/getSearchDetails',
  GETFILEDATA: '/updateDocument',
  VERIFYDEBITCARD: '/getDebitStatus',
  VERIFYAUTODEBITCARD: '/getAutopayStatus',
  GETUSERDETAIL: '/getUserDetails',
  GETCITY: '/getCityDetails',
  GETYEAR: '/getYearDetails',
  GETMFG: '/getManufacturerDetails',
  GETMODEL: '/getModelDetails',
  GETVARIANT: '/getVariantDetails',
  VERIFYLOANNUMBER: '/getLoanStatus',
  GETCARDEKHOLOCATIONDETAILS: '/getCarDekhoDetails',
  GETPRICINGDETAILS: '/getPricingDetails',
  GETLEADGENERATIONDETAILS: '/getLeadGenerationDetails',
  GENERATE_JWT_TOKEN_NLI: '/getToken',
  GETSERVICE_NLI: '/getServicesList',
  GETDROPDOWNLIST: '/getNliDetails',
  SUBMITGRIEVANCEFORM: '/grievanceDetails/generate',
  DEACTIVATE_TOKEN_NLI: '/deActivateToken',
  GRIEVANCESEARCH: "/grievanceDetails/search",
  PINCODE: '/getPincodeDetails',
  GETFOREXDETAIL: '/getForexReqDetails',
  GETHOMEPROPERTYDETAIL: '/getHompePropertyDetails',
  CONVERTTRANSACTIONTOEMI: '/convertTransactionToEMI',
  VERIFYDMATNUMBER: '/getInvestMentStatus',
  GETIANMGES: '/getGravityOffers',
  GETCREDITDETAILS: '/getCreditDetails',
  GETTINMASTERDETAILS: '/getTinMasterDetails',
  GETBANKUSERDETAILS: '/getBankUserDetails',
  VERIFYCOMMUNICATIONADDRESS: '/getProfileDetails',
  GETCREDITACCOUNTS: '/getCreditNumbers',
  GETGOOGLELOC:'/getGeoLocStatus',
  GETIBOX: '/getIboxMaster',
  GETBANKMASTERLIST: '/bankMasterList',
  GETBRANCHLISTFORSWAPPING : '/deptMasterList',
  GRIDAUTHENTICATIONCSP: '/gridAuthentication',
  ESIGN_SESSION_DBT:'/getEsignSession',
  ESIGN_UPDATE_DBT:'/getSignedDocument',

  //REKYC
  DEACTIVATE_REKYC_TOKEN: '/deActivateToken',
  REFRESH_REKYC_TOKEN: '/refreshToken',
  GETMASTERDATA: "/getMasterFields",
  GETALLMASTERDATA: "/getAllMasterFields",
  GETACCOUNTEMAIL: "/getAccountEmail",
  GETUPDATEDEMAIL: "/getUpdatedEmail",
  GETEMAILOTP: "/getEmailOTP",
  VERIFYEMAILOTP: "/verifyEmailOTP",
  UPDATEREKYCPAN: "/panUpdate",
  VALIDATEREKYCPAN: "/panValidate",
  UPDATEPROFILEMASTER: "/updateMasterField",
  PANVALIDATION:'/panValidation',
  GENERATEAADHAAROTP: "/generateAadhaarOtp",
  VERIFYAADHAAROTP: "/verifyAadhaarOtp",
  GETREKYCDETAILS: "/getRekycDetails",
  SAVEDEVICEDETAILS: "/saveDeviceDetails",
  GETGEOLOCATION: "/getGeoLocStatus",
  UPDATECURRENTADDRESS: "/updateCurrentAddr",
  UPDATEFATCADETAILS: "/updateFATCADetails",
  GETESIGNSESSION: "/getEsignSession",
  DELETEESIGNDOC: "/deleteEsignDoc",
  GETSIGNEDDOCUMENT: "/getSignedDocument",
  PROCEEDVKYC: "/proceedVideoKYC",

  // nli
  GETNSEDETAIL: '/getNSEDetails',
  SUBMITFEEDBACKDETAIL: '/getFeedbackReqDetailsForSR',
  SUBMITSERVICEREQUEST: '/getServiceReqDetails',
  GETLOANTRACKER: '/getLoanTrackerDetails',
  GETUNCLAIMEDDEPOSIT: '/unclaimedDepositDetails',
  GETSHAREHOLDER: '/shareHolderDetails',
  GETINVESTORUPLOAD: '/investorUploadDetails',
  GETPOS: '/getPOSServiceDetails',
  GETUNCLAIMEDIVIDENT: '/getUnclaimedDiviDetails',
  GETCOMPLIMENT: '/getComplimentsDetails',
  GETGDPR: '/GdprRequestDetails',
  GETkYC: '/getkycMailerDetails',
  GETQRDETAILS: '/getQRDetails',
  CALL_ON_CLOSE_OVEDUE: '/sendDropFlow',
  CARLOANDASHBOARD: '/getCarLoanStatus',
  TPU: '/getDepositAmount',
  RTGSFUNDS: '/getFundForRTGS',
  NEFTFUNDS: '/getFundForNEFT',
  ICICIFUNDS: '/getFundForIcici',
  AURASUBMIT: '/getAuraSRgenerate',
  PREPAIDBLOCK: '/getCardBlockReqDetails',
  PREPAIDPIN: '/getPinChangeReqDetails',
  PREPAIDUNBLOCK: '/getCardUnblockReqDetails',
  PREPAIDACTIVE: '/getActiveInActiveCardDetails',
  PREPAIDACTIVATE: '/getCardStatusDetails',
  PREPAIDCARDDETAIL: "/getPrepaidLoginDetails",
  PREPAIDUSER: "/getUserDetails",
  OFFERPORTALDETAILS: '/offerPortalDetails',
  GRIDCARDACCOUNTDETAILS: '/accountDet',
  GRIDCARDDEBITDETAILS: '/getDebitDetails',
  GETDONATIONDETAILS: '/getDonationDetails',
  GETCASHKARODETAILS: '/getCashKaroDetails',
  GETLOANQRDETAILS: '/getLoanQrDetails',
  GET_DECRYPTED_DATA_GRID: '/getDecryptedDataGrid',
  GET_EMAIL_OTP:"/getEmailOtp",
  VERIFY_EMAIL_OTP_NLI:"/verifyEmailOtp",

  //Pebble
  UPDATEVARIANT: '/updateVariant',
  GENERATE_SR: '/generateSR',
  UPLOAD_FILES_PEBBLE: "/getBase64Files",
  GRIDAUTH_PEBBLE: '/gridAuthentication',
  GETDEBIT_PEBBLE: '/getDebitDetails',
  GENERATEPDF: '/getSolvencyPDF',
  STATECITYDETAIL: '/getStateCityDetails',
  GETBRANCHBYPIN: '/getBranchByPin',
  GET_DROPDOWN_COUNTRY: '/getCountryDetails',
  GETOTP: '/generateMobileOtp',
  GETSBNROCONVERSION: '/getSbNroConvertion',
  VERIFYOTP_TIO: '/verifyMobileOtp',
  VERIFYDEBITPIN: '/validateDebitCardPin',
  GETBANKERSCERTIFICATE: '/getBankersCertificate',
  GETCONVERSIONPDF: '/getConversionPDF',
  GRIDAUTHENTICATION: '/gridAuthentication',
  GETCARDNUMBER: '/getDebitCardNumber',
  UPDATEESTATEMENT: '/updateEStatement',
  UPDATEETRADEALERTS: '/updateETradeAlerts',
  UPDATEMAILMOB: '/updateEmail',
  GETCONVERSIONAUTOSAVE: '/getAutoSavedDetails',
  GETCONVERSIONFILE: '/getDownloadFile',
  GENERATEOTPUPDATE: '/sendOtpForPin',
  VERIFYYOTPUPDATE: '/sendOtpForPin',
  GENERATEOTPUPDATEDEBIT: '/sendOtpForPin',
  VERIFYYOTPUPDATEDEBIT: '/sendOtpForPin',
  PREPAIDBLOCK: '/getCardBlockReqDetails',
  PREPAIDPIN: '/getPinChangeReqDetails',
  PREPAIDUNBLOCK: '/getCardUnblockReqDetails',
  PREPAIDACTIVE: '/getActiveInActiveCardDetails',
  PREPAIDACTIVATE: '/getCardStatusDetails',
  PREPAIDCARDDETAIL: "/getPrepaidLoginDetails",
  PREPAIDUSER: "/getUserDetails",

  // Data govenance microservice 
  GETDECRYPTEDDATADGOV:'/getDecryptedData',
  VERYFYPANDGOV:'/validatePan',
  GENERATAEMAILOTP:'/getEmailOtp',
  VERIFYEMAILOTPDOV:'/verifyEmailOtp',
  GRIDAUTHDGOV:'/gridAuthentication',
  SUBMITCUSTOMER:'/submitCustomerdDet',
  GET_SOURCE_ID:'/getSourceId',
  GETACCOUNTS:'/accounts',

  //dual residency
  GETDECRYPTEDDATADUAL:'/getDecryptedData',
  SUBMITCUSTOMERDET:'/submitCustomerdDet',

  //Overdue Income tax certificate
  GET_INCOMETAX: '/getLoanNumbers',

  // cash withdrawal
  GET_DECRYPTED_CASH_WITHDRAWAL: '/getDecryptedCashW',
  CASH_WITHDRAWAL_DETAIL: '/cashWithdrawalDetail',
  RAISE_SERVICE_REQUEST: '/raiseServiceRequest',
  GET_MOBILE_OTP: '/sendOtp',
  VERIFY_OTP: '/verifyOtp',

  // * m2m - minor to major
  M2M_VALIDATE_USER: '/validateUser',
  M2M_GET_USER_DETAILS: '/GetUserDetails',

  M2M_GET_M_OTP: '/getMOtp',
  M2M_VERIFY_M_OTP: '/verifyMOtp',

  M2M_GET_E_OTP: '/getEotp',
  M2M_VERIFY_E_OTP: '/verifyEotp',

  M2M_GET_A_OTP: '/getAOtp',
  M2M_VERIFY_A_OTP: '/verifyAOtp',
  M2M_GET_MASTER_LIST: '/getMasterList',
  M2M_VALIDATE_PAN: '/validatePan',
  M2M_GET_GEOLOCATION: '/getGeoLoc',
  M2M_GET_TOKEN: '/getToken',
  M2M_GET_NOMINEE: '/getNominee',
  M2M_GET_APPLICABLE_PRODUCTS: '/getApplicableProduct',
  M2M_SUBMIT: '/submit',
  M2M_VKYC: '/vkycInitiate',
  M2M_VKYC_FROM_URL: '/vkycFromUrl',
  M2M_VALIDATE_URL: '/validateM2mUrl',
  M2M_CRM_UPDATE: '/crmUpdate',
  
  // * forex doorstep
  FOREX_DOORSTEP_GET_CURRENCY: '/getCurrency',
  FOREX_DOORSTEP_GET_CONVERSION_RATES: '/getConversionRates',
  FOREX_DOORSTEP_GET_PINCODE_MASTER: '/getPincodeMaster',
  FOREX_DOORSTEP_GET_PINCODE_DETAILS: '/getPincodeDetails',
  FOREX_DOORSTEP_TOTAL_AMOUNT_PAYABLE: '/totalAmountPayable',
  FOREX_DOORSTEP_VERIFY_USER: '/verifyUser',
  FOREX_PURCHASE_REQ_GENERATION: '/purchaseReqGeneration',
  FOREX_DOORSTEP_TRIGGER_OTP: '/getDoorStepOtp',
  FOREX_DOORSTEP_VERIFY_OTP: '/verifyDoorStepOtp',
  FOREX_DOORSTEP_VERIFY_GRID_AUTH: '/doorstepGridAuthentication',
  FOREX_DOORSTEP_GET_PROMO_CODES: '/promoCode',
  FOREX_DOORSTEP_GET_LOGIN_OTP: '/getDoorstepOtp',
  FOREX_DOORSTEP_VERIFY_LOGIN_OTP: '/verifyDoorstepOtp',
  FOREX_DOORSTEP_PASSPORT_VERIFICATION: '/passportVerification',
  FOREX_DOORSTEP_SSO_DECRYPTED_DATA: '/getdecryptedData',

  //rekyc nochange
  REKYC_NOCHANGE: '/getDecryptedData',
  REKYC_NOCHANGE_SR: '/noChangeSRDeatils'
};
